module.exports = __webpack_public_path__ + "img/Division.605aedff.svg";